import { useCallback, useEffect, useRef, useState } from "react";
import { Table } from "antd";
import { HolderOutlined } from "@ant-design/icons";

const DraggableTable = ({
  data,
  columns,
  rowKey = "id",
  onIndexChange = null,
  ...tableProps
}) => {
  const [dataSource, setDataSource] = useState(data || []);
  const dragIndex = useRef(null);

  const handleDragStart = useCallback((index) => {
    dragIndex.current = index;
  }, []);

  useEffect(() => {
    setDataSource(data);
  }, [data]);

  const handleDrop = useCallback(
    (dropIndex) => {
      if (dragIndex.current === null || dragIndex.current === dropIndex) return;

      const fromIndex = dragIndex.current;

      setDataSource((prev) => {
        const updated = [...prev];
        const [moved] = updated.splice(fromIndex, 1);
        updated.splice(dropIndex, 0, moved);

        onIndexChange?.(updated, {
          fromIndex,
          toIndex: dropIndex,
          id: moved[rowKey],
          record: moved,
        });

        return updated;
      });

      dragIndex.current = null;
    },
    [onIndexChange, rowKey],
  );
  const draggableBodyRow = useCallback(
    (rowProps) => {
      const index = dataSource.findIndex(
        (item) => item[rowKey] === rowProps["data-row-key"],
      );

      return (
        <tr
          {...rowProps}
          draggable
          onDragStart={(e) => {
            handleDragStart(index);

            e.dataTransfer.effectAllowed = "move";
          }}
          onDragOver={(e) => e.preventDefault()}
          onDrop={() => handleDrop(index)}
          style={{ ...rowProps.style, cursor: "grab" }}
        />
      );
    },
    [dataSource, rowKey, handleDragStart, handleDrop],
  );

  const dragHandleColumn = {
    key: "drag_handle",
    width: 40,
    render: () => <HolderOutlined style={{ cursor: "grab", color: "#999" }} />,
  };

  return (
    <Table
      {...tableProps}
      rowKey={rowKey}
      dataSource={dataSource}
      columns={[dragHandleColumn, ...columns]}
      components={{ body: { row: draggableBodyRow } }}
    />
  );
};

export default DraggableTable;
